module.exports = __webpack_public_path__ + "img/logo_head.6c8bd463.png";